<template>
    <v-container fill>
        <oss-dialog
            title="Confirmation"
            v-model="dialogConfirmOperations"
            @valid="
                createOperations();
                dialogConfirmOperations = false;
            "
            max-width="40vw"
        >
            <div>Voulez-vous vraiment créer les opérations ?</div>
        </oss-dialog>
        <v-row no-gutters class="mb-2">
            <v-col cols="12" class="my-2">
                <v-btn-back @click.stop="backPath()"> </v-btn-back>
            </v-col>
            <v-col cols="12">
                <!-- // ** title -->
                <v-row no-gutters class="mb-2">
                    <v-col class="d-flex align-center col-auto pr-3">
                        Opérations de stock associées
                    </v-col>
                    <v-col class="d-flex align-center">
                        <v-divider />
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-2">
                    <v-col cols="12">
                        <template v-if="true">
                            <div no-gutters>
                                <v-card
                                    class="default_card_wm mx-auto py-2 mb-2"
                                    style="
                                        background: #fff !important;
                                        border: solid rgba(0, 0, 0, 0.12) 1px;
                                        box-shadow: none;
                                    "
                                >
                                    <v-data-table
                                        :headers="headers"
                                        :items="operations"
                                        class="table elevation-0"
                                        fixed-header
                                        max-height="60vh"
                                        :hide-default-footer="true"
                                        v-if="!$vuetify.display.mobile"
                                        density="compact"
                                    >
                                        <template v-slot:item="props">
                                            <tr :class="props.item.selected ? 'info' : ''">
                                                <td class="text-center">
                                                    <span
                                                        >{{ props.item.title }} -
                                                        {{ props.item.reference }}</span
                                                    >
                                                </td>
                                                <td class="text-center">
                                                    <span>{{ props.item.quantity }}</span>
                                                </td>
                                                <td class="text-center">
                                                    <span>{{ props.item.price }}</span>
                                                </td>
                                                <td class="text-center" style="cursor: pointer">
                                                    <!-- <span
                                                            @click.stop="openQuantityEditDialog(props.item)"
                                                        >
                                                            {{props.item.quantity}}
                                                            <v-icon  size="small">
                                                                $oss-edit
                                                            </v-icon>
                                                        </span> -->
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-slot:body.append>
                                            <tr>
                                                <td class="text-center">
                                                    <v-select-filled
                                                        hide-details
                                                        style="pointer-events: auto"
                                                        v-model="stockOperation.stockProduct"
                                                        :items="products"
                                                        return-object
                                                        class="v-select-font-size mt-2"
                                                        density="compact"
                                                        :item-title="(item) => item.title"
                                                    />
                                                </td>
                                                <td class="text-center">
                                                    <oss-text-field-filled
                                                        :hide-details="true"
                                                        class="ml-2 mt-2 righted-input"
                                                        v-model="stockOperation.quantity"
                                                        :rules="[
                                                            (v) =>
                                                                v > 0 ||
                                                                $t('settings.positiveNumber'),
                                                        ]"
                                                    >
                                                    </oss-text-field-filled>
                                                </td>
                                                <td class="text-center">
                                                    <oss-text-field-filled
                                                        :hide-details="true"
                                                        class="ml-2 mt-2 righted-input"
                                                        v-model="stockOperation.price"
                                                    >
                                                    </oss-text-field-filled>
                                                </td>
                                                <td class="text-center" style="cursor: pointer">
                                                    <v-btn-add-icon
                                                        size="x-small"
                                                        @click="addRow()"
                                                        class="mt-2"
                                                        :disabled="
                                                            stockOperation.quantity <= 0 ||
                                                            stockOperation.price <= 0
                                                        "
                                                    >
                                                    </v-btn-add-icon>
                                                </td>
                                            </tr>
                                            <!-- <tr>
                                                    <td colspan="3">
                                                        <v-row no-gutters class="pt-2">
                                                            <v-col cols="5">
                                                                <v-select
                                                                    label="Produit"
                                                                    hide-details
                                                                    outlined dense
                                                                    style="pointer-events: auto;"
                                                                    v-model="stockOperation.stockProduct"
                                                                    :items="products"
                                                                    item-text="title"
                                                                    return-object
                                                                    class="oss- v-select-font-size"
                                                                ></v-select>
                                                            </v-col>
                                                            <v-col cols="2">
                                                                <oss-text-field
                                                                    dense
                                                                    filled
                                                                    :hide-details="true"
                                                                    outlined
                                                                    label="Quantité"
                                                                    type="number"
                                                                    class="ml-2 righted-input oss-"
                                                                    v-model="stockOperation.quantity"
                                                                    >
                                                                </oss-text-field>
                                                            </v-col>
                                                            <v-col cols="3">
                                                                <oss-text-field
                                                                    dense
                                                                    filled
                                                                    :hide-details="true"
                                                                    outlined
                                                                    label="Prix"
                                                                    type="number"
                                                                    class="ml-2 righted-input oss-"
                                                                    v-model="stockOperation.price"
                                                                    >
                                                                </oss-text-field>
                                                            </v-col>
                                                            <v-col cols="2" class="d-flex align-center pl-2">
                                                                <v-btn

                                                                    elevation="0"
                                                                     size=“x-small”
                                                                    fab
                                                                    @click="addRow()"
                                                                >
                                                                    <v-icon  size="small">$add</v-icon>
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </td>
                                                </tr> -->
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </div>
                        </template>
                        <v-row no-gutters class="my-2">
                            <v-col>
                                <v-spacer />
                            </v-col>
                            <v-col cols="auto" class="d-flex align-center">
                                <v-btn
                                    @click="dialogConfirmOperations = true"
                                    elevation="0"
                                    rounded
                                    size="small"
                                >
                                    Valider
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row></v-container
    >
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import OssDataTable from "../ossComponents/ossDataTable2.vue";
import SAVE_STOCK_OPERATION from "../../graphql/stock/SaveStockOperation.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

// import STOCK_OPERATIONS from "../../graphql/stock/StockOperationsFromDocument.gql"

@Component({
    components: {
        OssDataTable,
    },
    emits: ["upsert", "back"],
})
export class StockOpDocumentEdition extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: undefined }) documentId: any;
    // @Prop({ default: null }) document: any;

    dialogConfirmOperations = false;

    products = [];
    operations = [];

    stockOperation = {
        stockProduct: null,
        quantity: 0,
        price: 0,
    };

    defaultStockOperation = {
        stockProduct: null,
        quantity: 0,
        price: 0,
    };

    // stockProducts = []

    get headers() {
        const headers: Array<any> = [
            { title: "Produit", value: "product", align: "center" },
            { title: "Quantité", value: "quantity", align: "center" },
            { title: "Prix", value: "price", align: "center" },
            { title: "", value: "action", align: "center" },
        ];
        return headers;
    }

    onUpsert() {
        this.$emit("upsert");
    }

    @Apollo({
        query: gql`
            query document($documentId: ID!) {
                document(
                    where: { id: $documentId } # companyId: $companyId,
                ) {
                    id
                    date
                    accountingLines {
                        thirdPartyCompany {
                            isThirdPartyCompanyOfInvoiceProducts {
                                id
                                title
                                reference
                            }
                        }
                    }
                    stockOperations {
                        id
                        stockProduct {
                            id
                            title
                            reference
                        }
                        quantity
                        price
                        unitPrice
                        type
                    }
                }
            }
        `,
        variables() {
            this.productLoading = true;
            return {
                documentId: this.documentId,
            };
        },
        skip() {
            return !this.documentId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                this.productLoading = false;
                this.document = data.document;
                this.getProductsAndOperations();
            }
        },
    })
    document: any;

    getProductsAndOperations() {
        if (this.document?.accountingLines?.length) {
            const thirdPartyAL = this.document.accountingLines.find(
                (x) => x.thirdPartyCompany !== null,
            );
            if (thirdPartyAL) {
                this.products =
                    thirdPartyAL.thirdPartyCompany.isThirdPartyCompanyOfInvoiceProducts.map(
                        (prod) => {
                            return {
                                title: prod.title,
                                reference: prod.reference,
                                id: prod.id,
                                unitPrice: 0,
                            };
                        },
                    );
            }
        }
        debugger;
        if (this.document.stockOperations?.length) {
            this.operations = this.document.stockOperations.map((op) => {
                return {
                    id: op.id,
                    title: op.stockProduct.title,
                    // reference: op.stockProduct.reference,
                    stockProductId: op.stockProduct.id,
                    documentId: this.documentId,
                    // documentId: this.document.id,
                    date: this.document.date,
                    quantity: Math.abs(op.quantity),
                    price: Math.abs(op.price),
                    unitPrice: op.unitPrice,
                };
            });
        } else {
            this.operations = [];
        }
    }

    get sign() {
        if (this.document.type === "SALES_INVOICE" || this.document.type === "ZTILL_RECEIPT") {
            return this.document.creditNote ? -1 : 1;
        }
        return this.document.creditNote ? 1 : -1;
    }

    async createOperations() {
        for (const operation of this.operations) {
            const stockOperation = {
                id: operation.id,
                stockProductId: operation.stockProductId,
                documentId: operation.documentId,
                quantity: this.sign * Math.abs(operation.quantity),
                price: operation.price,
                unitPrice: this.sign * Math.abs(operation.unitPrice),
            };
            await this.$apollo.mutate({
                mutation: SAVE_STOCK_OPERATION,
                variables: {
                    selectedCompanyId: this.companyId,
                    stockOperation,
                    productTagId: undefined,
                },
            });
        }
        this.backPath();
    }

    async addRow() {
        this.operations.push({
            id: "",
            title: this.stockOperation.stockProduct.title,
            // reference: this.stockOperation.stockProduct.reference,
            stockProductId: this.stockOperation.stockProduct.id,
            quantity: this.stockOperation.quantity,
            price: this.stockOperation.price,
            unitPrice: this.stockOperation.price / this.stockOperation.quantity,
            date: this.document.date,
            documentId: this.documentId,
            // documentId: this.document.id,
        });
        this.stockOperation = JSON.parse(JSON.stringify(this.defaultStockOperation));
    }

    backPath() {
        this.$emit("back");
    }
}

export default toNative(StockOpDocumentEdition);
</script>

<style scoped>
.wrapper {
    /* max-width: 200px; */
    white-space: normal;
}

.text-wrapped {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
